(function () {
	if (typeof posthog === 'undefined') {
		return;
	}

	// 1. Fånga vanliga JS-fel
	window.onerror = function (message, source, lineno, colno, error) {
		posthog.capture('exception', {
			message: message,
			source: source,
			lineno: lineno,
			colno: colno,
			type: error?.name || 'Error',
			stacktrace: error?.stack || null,
			url: window.location.href
		});
	};

	// 2. Fånga async-fel (unhandled promises)
	window.addEventListener('unhandledrejection', function (event) {
		posthog.capture('exception', {
			message: event.reason?.message || event.reason || 'Unhandled promise rejection',
			type: event.reason?.name || 'UnhandledRejection',
			stacktrace: event.reason?.stack || null,
			url: window.location.href
		});
	});

	// 3. Fånga XHR-fel och svar med 500/PHP-error-innehåll
	(function(open) {
		XMLHttpRequest.prototype.open = function(method, url) {
			this._method = method;
			this._url = url;

			this.addEventListener('load', function () {
				if (this.status >= 500 || this.status === 0) {
					posthog.capture('exception', {
						message: `XHR failed: ${this.status} ${this.statusText}`,
						type: 'XHRResponseError',
						stacktrace: this.responseText?.substring(0, 500),
						url: this._url,
						status: this.status
					});
				}
			});

			this.addEventListener('error', function () {
				posthog.capture('exception', {
					message: `XHR transport error to ${this._url}`,
					type: 'XHRTransportError',
					stacktrace: null,
					url: this._url,
					status: this.status
				});
			});

			open.apply(this, arguments);
		};
	})(XMLHttpRequest.prototype.open);

	// 4. Fånga Fetch-fel & 500-svar
	const origFetch = window.fetch;
	window.fetch = function () {
		return origFetch.apply(this, arguments).then(async response => {
			if (!response.ok) {
				const text = await response.clone().text();
				posthog.capture('exception', {
					message: `Fetch failed: ${response.status} ${response.statusText}`,
					type: 'FetchError',
					stacktrace: text.substring(0, 500),
					url: response.url,
					status: response.status
				});
			}
			return response;
		}).catch(error => {
			posthog.capture('exception', {
				message: error.message,
				type: error.name || 'FetchTransportError',
				stacktrace: error.stack || null,
				url: window.location.href
			});
			throw error;
		});
	};

	// 5. Hjälpfunktion: upptäcker typiska PHP-fel i HTML-svar
	function isPHPError(text) {
		const lowered = text.toLowerCase();
		return lowered.includes('fatal error') ||
			lowered.includes('parse error') ||
			lowered.includes('warning') ||
			lowered.includes('notice') ||
			lowered.includes('<br />') && lowered.includes('in ') && lowered.includes('.php');
	}

})();
